import Client from 'models/claims/client/Model.Client';
import Dealer from 'models/dealerManagement/dealer/Model.Dealer';
import RefundPayee from 'models/finance/refundPayee/Model.RefundPayee';
import Model from 'models/Model';
import Lender from 'models/sales/lender/Model.Lender';

export default class ContractRefundPayee
  extends Model<Model.IContractRefundPayee>({ icon: 'fas-cloud' })
  implements Model.Instance<Model.IContractRefundPayee>
{
  id: number;
  isPrimary: boolean;
  paymentMethodCode: string;

  payeeId?: number;
  payee?: RefundPayee;

  clientId?: number;
  client?: Client;

  dealerId?: number;
  dealer?: Dealer;

  lenderId?: number;
  lender?: Lender;

  constructor(
    data: Partial<Model.IContractRefundPayee> | Utils.FormData<Model.IContractRefundPayee>,
    language?: Locale.Languages
  ) {
    super(
      {
        payee: RefundPayee,
        client: Client,
        dealer: Dealer,
        lender: Lender,
      },
      language
    );
    this.update(data);
  }

  get displayInfo(): Model.DisplayInfo {
    const payee = this?.payee ?? this.dealer ?? this.client ?? this.lender;
    return {
      id: this.id,
      title: payee?.name ?? this.id?.toString(),
      subtitle: payee?.fullAddress,
    };
  }

  get fullAddress(): string | undefined {
    return this.payee?.fullAddress ?? this.dealer?.fullAddress ?? this.client?.fullAddress ?? this.lender?.fullAddress;
  }

  get addressDetails(): Model.AddressDetails {
    const payee = this.payee ?? this.dealer ?? this.client ?? this.lender;

    if (!payee) {
      return null;
    }

    return {
      city: payee.city,
      province: payee.provinceCode,
      postalCode: payee.postalCode,
      countryCode: payee.countryCode,
    };
  }
}
